import {useMemo} from 'react'
import {useDispatch} from 'react-redux'
import {usePermissions} from 'src/app/hooks/permissions.hook'
import {IProfile} from 'src/app/models'
import {EPermissions, TPermissions} from 'src/app/models/User/Permission.model'
import AdministrationScreens from 'src/app/modules/administration/routes/Screens'
import DashboardScreens from 'src/app/modules/dashboard/routes/Screen'
import JobScreens from 'src/app/modules/job-tugas/routes/Screen'
// import KalenderScreens from 'src/app/modules/kalender-job/routes/Screen'
import SettingScreens from 'src/app/modules/setting/routes/Screen'
import UserScreens from 'src/app/modules/user/routes/Screen'
import WorkOrderScreens from 'src/app/modules/work-order/routes/Screen'
import JobRedux from 'src/app/store/Job/JobRedux'

export interface Menu {
  id?: string
  to?: string
  title: string
  icon?: string
  fontIcon?: string
  hasBullet?: boolean
  children?: Menu[]
  permission?: TPermissions
  activePath?: string
  badge?: string
  badgeCircle?: boolean
  hidden?: boolean
  disabled?: boolean
  notifity?: number
  onClick?: () => void
}

export const useMenus = (user?: IProfile, notification?: any): Menu[] => {
  const {hasAccess} = usePermissions()
  const userLevel: string = user?.level?.type as string
  const dispatch = useDispatch()

  return useMemo(
    () =>
      [
        {
          children: [
            // DASHBOARD
            {
              to: DashboardScreens.DASHBOARD.PATH,
              icon: '/media/icons/IconDashboard.svg',
              title: DashboardScreens.DASHBOARD.TITLE,
              hidden: ['L0'].includes(userLevel) || !hasAccess([EPermissions.DASHBOARD_READ]),
            },
            // KALENDER JOB
            // {
            //   to: KalenderScreens.KALENDER_LIST.PATH,
            //   activePath: KalenderScreens.KALENDER.PATH,
            //   icon: '/media/icons/IconCalendar.svg',
            //   title: KalenderScreens.KALENDER.TITLE,
            //   hidden: ['L0'].includes(userLevel) || !hasAccess([EPermissions.JOB_CALENDAR_READ]),
            // },
            // USER
            {
              to: UserScreens.USER.PATH,
              icon: '/media/icons/IconUser.svg',
              title: UserScreens.USER.TITLE_ALT,
              hidden:
                ['L0'].includes(userLevel) ||
                !hasAccess([EPermissions.ADMIN_READ, EPermissions.AGENT_READ]),
              children: [
                {
                  to: UserScreens.USER_ADMIN_LIST.PATH,
                  activePath: UserScreens.USER_ADMIN.PATH,
                  title: UserScreens.USER_ADMIN.TITLE,
                  hasBullet: true,
                  hidden: !hasAccess([EPermissions.ADMIN_READ]),
                },
                {
                  to: UserScreens.USER_AGEN_LIST.PATH,
                  activePath: UserScreens.USER_AGEN.PATH,
                  title: UserScreens.USER_AGEN.TITLE,
                  hasBullet: true,
                  hidden: !hasAccess([EPermissions.AGENT_READ]),
                },
              ],
            },
            // JOB & TUGAS
            {
              to: JobScreens.JOB.PATH,
              icon: '/media/icons/IconTugasAgen.svg',
              title: JobScreens.JOB.TITLE_ALT,
              hidden:
                ['L0'].includes(userLevel) ||
                !hasAccess([
                  EPermissions.JOB_CREATE,
                  EPermissions.JOB_READ,
                  EPermissions.JOB_APPROVAL_READ,
                ]),
              notifity: notification?.total_approval,
              children: [
                {
                  to: JobScreens.JOB_TUGAS_ADD.PATH,
                  activePath: JobScreens.JOB_TUGAS_ADD.PATH,
                  title: JobScreens.JOB_TUGAS_ADD.TITLE_ALT,
                  hasBullet: true,
                  hidden: !hasAccess([EPermissions.JOB_CREATE]),
                  onClick: () => dispatch(JobRedux.actions.setResetForm()),
                },
                {
                  to: JobScreens.JOB_TUGAS_UPLOAD.PATH,
                  activePath: JobScreens.JOB_TUGAS_UPLOAD.PATH,
                  title: JobScreens.JOB_TUGAS_UPLOAD.TITLE_ALT,
                  hasBullet: true,
                  hidden: !hasAccess([EPermissions.JOB_CREATE]),
                },
                {
                  to: JobScreens.JOB_TUGAS_LIST_DRAFT.PATH,
                  activePath: JobScreens.JOB_TUGAS_LIST_DRAFT.PATH,
                  title: JobScreens.JOB_TUGAS_LIST_DRAFT.TITLE_ALT,
                  hasBullet: true,
                  hidden: !hasAccess([EPermissions.JOB_READ]),
                },
                {
                  to: JobScreens.JOB_TUGAS_LIST_ACTIVE.PATH,
                  activePath: JobScreens.JOB_TUGAS_LIST_ACTIVE.PATH,
                  title: JobScreens.JOB_TUGAS_LIST_ACTIVE.TITLE_ALT,
                  hasBullet: true,
                  hidden: !hasAccess([EPermissions.JOB_READ]),
                },
                {
                  to: JobScreens.PERSETUJUAN_TUGAS_LIST_WAITING.PATH,
                  activePath: JobScreens.PERSETUJUAN_TUGAS.PATH,
                  title: JobScreens.PERSETUJUAN_TUGAS_LIST_WAITING.TITLE_ALT,
                  hasBullet: true,
                  notifity: notification?.total_approval,
                  hidden: !hasAccess([EPermissions.JOB_APPROVAL_READ]),
                },
              ],
            },
            // WORK ORDER
            {
              to: WorkOrderScreens.WORK_ORDER.PATH,
              icon: '/media/icons/IconJobTask.svg',
              title: WorkOrderScreens.WORK_ORDER.TITLE_ALT,
              hidden:
                ['L0'].includes(userLevel) ||
                !hasAccess([
                  EPermissions.WORK_ORDER_INCOMING_READ,
                  EPermissions.WORK_ORDER_OUTGOING_READ,
                ]),
              children: [
                {
                  to: WorkOrderScreens.WO_OUTGOING_ADD.PATH,
                  activePath: WorkOrderScreens.WO_OUTGOING_ADD.PATH,
                  title: WorkOrderScreens.WO_OUTGOING_ADD.TITLE_ALT,
                  hasBullet: true,
                  hidden: !hasAccess([EPermissions.WORK_ORDER_INCOMING_READ]),
                },
                {
                  to: WorkOrderScreens.WO_INCOMING_LIST.PATH,
                  activePath: WorkOrderScreens.WO_INCOMING_LIST.PATH,
                  title: WorkOrderScreens.WO_INCOMING_LIST.TITLE_ALT,
                  hasBullet: true,
                  hidden: !hasAccess([EPermissions.WORK_ORDER_INCOMING_READ]),
                },
                {
                  to: WorkOrderScreens.WO_OUTGOING_LIST.PATH,
                  activePath: WorkOrderScreens.WO_OUTGOING_LIST.PATH,
                  title: WorkOrderScreens.WO_OUTGOING_LIST.TITLE_ALT,
                  hasBullet: true,
                  hidden: !hasAccess([EPermissions.WORK_ORDER_OUTGOING_READ]),
                },
              ],
            },
            // AKTIVITAS LOG
            // {
            //   to: LogActivityScreens.LOG_LIST_AGEN.PATH,
            //   activePath: LogActivityScreens.LOG_ACTIVITY.PATH,
            //   icon: '/media/icons/IconClock.svg',
            //   title: LogActivityScreens.LOG_ACTIVITY.TITLE,
            //   hidden: ['L0'].includes(userLevel),
            // },
            // SETTING
            {
              to: SettingScreens.SETTING.PATH,
              icon: '/media/icons/IconSetting.svg',
              title: SettingScreens.SETTING.TITLE_ALT,
              hidden:
                ['L0'].includes(userLevel) ||
                !hasAccess([
                  EPermissions.ORGANIZATION_READ,
                  EPermissions.COMPANY_READ,
                  EPermissions.DEPARTMENT_READ,
                  EPermissions.PERMISSION_READ,
                  EPermissions.JOB_TEMPLATE_READ,
                ]),
              children: [
                {
                  to: SettingScreens.SETTING_ORGANISASI.PATH,
                  activePath: SettingScreens.SETTING_ORGANISASI.PATH,
                  title: SettingScreens.SETTING_ORGANISASI.TITLE,
                  hasBullet: true,
                  hidden:
                    !['L1'].includes(userLevel) || !hasAccess([EPermissions.ORGANIZATION_READ]),
                },
                {
                  to: SettingScreens.SETTING_PERUSAHAAN.PATH,
                  activePath: SettingScreens.SETTING_PERUSAHAAN.PATH,
                  title: SettingScreens.SETTING_PERUSAHAAN.TITLE,
                  hasBullet: true,
                  hidden:
                    !['L1', 'L2'].includes(userLevel) || !hasAccess([EPermissions.COMPANY_READ]),
                },
                {
                  to: SettingScreens.SETTING_DEPARTEMEN.PATH,
                  activePath: SettingScreens.SETTING_DEPARTEMEN.PATH,
                  title: SettingScreens.SETTING_DEPARTEMEN.TITLE,
                  hasBullet: true,
                  hidden: !hasAccess([EPermissions.DEPARTMENT_READ]),
                },
                {
                  to: UserScreens.USER_HAK_AKSES_LIST.PATH,
                  activePath: UserScreens.USER_HAK_AKSES.PATH,
                  title: UserScreens.USER_HAK_AKSES.TITLE,
                  hasBullet: true,
                  hidden: !hasAccess([EPermissions.PERMISSION_READ]),
                },
                {
                  to: SettingScreens.SETTING_TEMPLATE_TUGAS.PATH,
                  activePath: SettingScreens.SETTING_TEMPLATE_TUGAS.PATH,
                  title: SettingScreens.SETTING_TEMPLATE_TUGAS.TITLE,
                  hasBullet: true,
                  hidden: !hasAccess([EPermissions.JOB_TEMPLATE_READ]),
                },
              ],
            },
            // CLIENT
            {
              to: AdministrationScreens.ADMINISTRATION.PATH,
              icon: '/media/icons/IconBuilding2.svg',
              title: AdministrationScreens.ADMINISTRATION.TITLE,
              hidden: !['L0'].includes(userLevel),
              children: [
                {
                  to: AdministrationScreens.ORGANIZATION.PATH,
                  activePath: AdministrationScreens.ORGANIZATION.PATH,
                  title: AdministrationScreens.ORGANIZATION.TITLE,
                  hasBullet: true,
                },
                {
                  to: AdministrationScreens.PERUSAHAAN_LIST.PATH,
                  activePath: AdministrationScreens.PERUSAHAAN_LIST.PATH,
                  title: AdministrationScreens.PERUSAHAAN_LIST.TITLE,
                  hasBullet: true,
                },
                {
                  to: AdministrationScreens.DEPARTEMEN_LIST.PATH,
                  activePath: AdministrationScreens.DEPARTEMEN_LIST.PATH,
                  title: AdministrationScreens.DEPARTEMEN_LIST.TITLE,
                  hasBullet: true,
                },
              ],
            },
          ],
        },
      ] as Menu[],
    [notification, userLevel, hasAccess, dispatch]
  )
}
